import { UserInfo } from "@/api/rest/models/account";

export function isDobuEmployee(account?: UserInfo | null): boolean {
  if (!account?.email) {
    return false;
  }
  const email = account.email.toLowerCase();
  return (
    email.endsWith("dobu.ee") || email.endsWith("dobu.app") || email.endsWith("dobu.lv") || email.endsWith("dobu.me")
  );
}
